webpackJsonp([103532031831291],{

/***/ 109:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Artist = function Artist(props) {
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        background: '#171717',
	        color: '#cfcfcf',
	        textAlign: 'center',
	        padding: '20px',
	        margin: '0 10px 0 10px',
	        'border': '1px solid grey',
	        ':hover': { background: '#333333' }
	      }
	    },
	    Glamor.createElement(
	      'a',
	      { href: props.sc_url, target: 'new', css: {
	          textDecoration: 'none',
	          color: '#cfcfcf',
	          fontFamily: 'Roboto, sans-serif',
	          fontSize: '20px'
	        } },
	      Glamor.createElement('img', { src: props.img_url, style: { height: '250px', width: '250px' } }),
	      Glamor.createElement(
	        'div',
	        null,
	        props.name
	      )
	    )
	  );
	};
	
	exports.default = Artist;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(51);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _artist = __webpack_require__(246);
	
	var _artist2 = _interopRequireDefault(_artist);
	
	var _glamor = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var artistContainer = (0, _glamor.css)({
	        paddingBottom: '50px'
	});
	
	var artistRow = (0, _glamor.css)({
	        margin: '40px 0 10px 20px',
	        display: 'inline-flex',
	        flexDirection: 'row',
	        justifyContent: 'center',
	        alignItems: 'center',
	        flexWrap: 'wrap'
	});
	
	var Artists = function Artists() {
	        return Glamor.createElement(
	                'div',
	                { className: artistContainer },
	                Glamor.createElement(
	                        'div',
	                        { className: artistRow },
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/12x12_press_photo.jpg',
	                                name: '12 x 12',
	                                sc_url: 'https://soundcloud.com/12x12' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/lestasi_press_photo.jpg',
	                                name: 'L\'estasi Dell\'oro',
	                                sc_url: 'https://soundcloud.com/lestasi-delloro' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/nconduit_press_photo.jpg',
	                                name: 'N\'conduit',
	                                sc_url: 'https://soundcloud.com/nconduit' })
	                ),
	                Glamor.createElement(
	                        'div',
	                        { className: artistRow },
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/antonzap_press_photo.jpg',
	                                name: 'AntonZap',
	                                sc_url: 'https://soundcloud.com/antonzap' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/beaner_press_photo.jpg',
	                                name: 'Beaner',
	                                sc_url: 'https://soundcloud.com/beaner' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/bls_press_photo.jpg',
	                                name: 'Black Light Smoke',
	                                sc_url: 'https://soundcloud.com/black-light-smoke' })
	                ),
	                Glamor.createElement(
	                        'div',
	                        { className: artistRow },
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/deadbeat_press_photo.jpg',
	                                name: 'Deadbeat',
	                                sc_url: 'https://soundcloud.com/deadbeat' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/maddermodes_press_photo.jpg',
	                                name: 'MadderModes',
	                                sc_url: 'https://soundcloud.com/maddermodes' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/october_press_photo.jpg',
	                                name: 'October',
	                                sc_url: 'https://soundcloud.com/october' })
	                ),
	                Glamor.createElement(
	                        'div',
	                        { className: artistRow },
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/omf_press_photo.jpg',
	                                name: 'Our Mutual Friend',
	                                sc_url: 'https://soundcloud.com/ourmutualfriendmusic' }),
	                        Glamor.createElement(_artist2.default, { img_url: 'http://vdr.s3.amazonaws.com/site_assets/stl_press_photo.jpg',
	                                name: 'STL',
	                                sc_url: 'http://www.something-records.com/' })
	                )
	        );
	};
	
	exports.default = Artists;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-artists-js-fe841286d47140b81e80.js